<template>
  <div class="mx-container">
    <div class="mycontainer">
      <el-table
        :max-height="height"
        v-loading="listLoading"
        :data="list"
        fit
        highlight-current-row
        :header-cell-style="tableHeaderColor"
        :default-sort="{ prop: 'date', order: 'descending' }"
        tooltip-effect="dark"
      >
        <el-table-column
          label="认领人"
          align="left"
          prop="rlName"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="任务编号"
          align="left"
          prop="rwbh"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="任务标题"
          align="left"
          prop="title"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="所属条线"
          align="left"
          prop="txlxString"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="任务类型"
          align="left"
          prop="name"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="子类"
          align="left"
          prop="sun"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="任务状态"
          align="left"
          prop="statusString"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="申请人"
          align="left"
          prop="createBy"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="申请人部门/职位"
          align="left"
          prop="bmzw"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="任务开始时间"
          align="left"
          prop="qsrq"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="任务结束时间"
          align="left"
          prop="jsrq"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="任务申请时间"
          align="left"
          prop="createTime"
          min-width="150px"
          :show-overflow-tooltip="true"
        />
        <template slot="empty">
          <div class="nodata">
            <img src="@/img/nodata.png" alt="" width="160" />
            <div>暂无数据</div>
          </div>
        </template>
      </el-table>
      <pagination
        v-show="total > 0"
        :total="total"
        :page.sync="listQuery.page"
        :limit.sync="listQuery.pageSize"
        @pagination="getList"
      />
    </div>
  </div>
</template>
<script>
import Pagination from "@/components/Pagination";
import { getRlmxList } from "@/api/task.js";
import "moment/locale/zh-cn";

export default {
  components: { Pagination },
  name: "rlmx",
  props: ["mxParams"],
  data() {
    return {
      height: 100,
      listQuery: {
        id: "",
      },
      list: [],
      listLoading: true,
      total: 0,
    };
  },

  created() {
    this.listQuery.id = this.mxParams.id;
    this.getList();
  },

  methods: {
    getList() {
      this.listLoading = true;
      getRlmxList(this.listQuery).then((res) => {
        if (res.code == 0) {
          this.list = res.data;
          this.total = res.count;
          this.listLoading = false;
          const docH = document.documentElement.clientHeight;
          const mycontainerH =
            document.querySelector(".mycontainer").clientHeight;
          this.height = docH - mycontainerH - 50;
        }
      });
    },

    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f2f2f2;";
      }
    },
  },
};
</script>
<style lang="less" scoped>
.mx-container {
  padding: 0 20px 20px 20px;
}
.flex-button {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 5%;
}
.choice-box {
  border: 1px solid;
  border-color: #cccc;
  display: auto;
}
.app-container {
  padding: 10px;
}
.mycontainer {
  padding: 10px;
  background-color: #fff;
  border-radius: 6px;
}
.mycontainer .el-form-item {
  margin-bottom: 5px;
}
.filter-container {
  background-color: #fff;
  padding: 0;
}
.filter-container .filter-item {
  margin-bottom: 0;
}
.search-container {
  border: 0;
}
.btn-container {
  padding-top: 0px;
  margin-top: 10px;
  background-color: #f2f2f2;
  border-top: #e2e2e2 1px solid;
  border-left: #e2e2e2 1px solid;
  border-right: #e2e2e2 1px solid;
}
.dialog-footer {
  text-align: center;
}
.dialog-header {
  background-color: #f2f2f2;
  margin: 5px 5px;
}
.btn {
  display: block;
  margin: 10px 10px;
  width: 120px;
  height: 40px;
  font-size: 14px;
  line-height: 40px;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.08);
  cursor: pointer;
}
.avatar {
  display: block;
  width: 60px;
  margin: 10px 10px;
}
.el-button + .el-button {
  margin-left: 0px;
}
.el-input__inner {
  width: 100%;
}

.flex-container {
  display: -webkit-flex;
  display: flex;
  -webkit-align-items: center;
  align-items: center;
  -webkit-justify-content: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.flex-item1 {
  width: 40%;
  margin: 1%;
  min-height: 203.69px;
}
.flex-item2 {
  width: 80px;
  height: 70px;
}
.flex-item3 {
  width: 40%;
  margin: 1%;
  min-height: 203.69px;
}
.el-table__row > td {
  border: none;
}
.el-table::before {
  height: 0px;
}
.el-table th.is-leaf,
.el-table td {
  border-bottom: 0px;
}

::v-deep .el-dialog {
  width: 64%;
}
::v-deep .el-transfer-panel {
  width: 263px;
}
.pagination-container {
  border: none;
}
::v-deep #save-form .el-form-item__label {
  width: 150px !important;
}
::v-deep #save-form .el-form-item__content {
  margin-left: 150px !important;
}
::v-deep #save-form .el-select {
  width: 100% !important;
}
</style>
